<template>
  <div class="invest">
    <div class="content">
      <div class="titles">充值金额（元）</div>
      <div class="money_bar">
        <div class="money_logo">￥</div>
        <div>
          <input
            type="number"
            class="money_ipt"
            v-model="money"
            @input="handleChange($event)"
          />
        </div>
      </div>
      <div class="check_money">
        <div
          class="check_item"
          v-for="item in this.checkList"
          :key="item"
          @click="setCheckMoney(item)"
        >
          {{ item }}元
        </div>
      </div>
      <div class="send_btn" @click="handlePay">确定</div>
    </div>
    <loading v-show="load"></loading>
  </div>
</template>
<script>
import wx from "weixin-jsapi";
export default {
  name: "invide",
  data() {
    return {
      checkList: [1000, 2000, 3000, 4000, 5000, 6000],
      money: 1000,
      disabled: false,
      load: false
    };
  },
  mounted() {
    let url = window.location.href.split("#")[0];
    url = encodeURIComponent(url);
    this.Request(
      "api/v1/wechat/jsapi/signature",
      { url, terminalID: localStorage.getItem("payclient") },
      r => {
        if (r.data.code == "20000") {
          const { data } = r;
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: data.data.appid, // 必填，公众号的唯一标识
            timestamp: data.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.data.nonceStr, // 必填，生成签名的随机串
            signature: data.data.signature, // 必填，签名
            jsApiList: ["chooseWXPay"]
          });
        } else {
          alert(r.data.msg);
        }
      },
      err => {
        alert(err);
      }
    );
  },
  methods: {
    handleChange(e) {},
    setCheckMoney(e) {
      this.money = e;
    },
    handlePay() {
      this.load = true;
      this.Request(
        "api/v1/payment/jsapi/prepay",
        {
          amount: { total: this.money * 100 },
          payer: { sub_openid: localStorage.getItem("code") }
        },
        r => {
          let that = this;
          if (r.data.code == "20000") {
            wx.ready(function() {
              wx.chooseWXPay({
                timestamp: r.data.data.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: r.data.data.nonceStr, // 支付签名随机串，不长于 32 位
                package: `prepay_id=${r.data.data.prepay_id}`, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
                signType: r.data.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign: r.data.data.paySign, // 支付签名
                success: function(res) {
                  that.load = false;
                  window.location.href = "/#/invest";
                },
                cancel: function(res) {
                  that.load = false;
                  alert("已取消支付");
                },
                fail: function(res) {
                  that.load = false;
                  // alert("购买失败，请重新创建订单");
                }
              });
            });
          } else {
            alert(r.data.msg);
          }
        },
        err => {
          console.log(err);
        }
      );
    }
  }
};
</script>
<style scoped>
.invest {
  font-size: 8px;
  width: 100%;
  height: 100%;
  overflow: scroll;
  background: white;
}
.content {
  width: 90%;
  margin-left: 5%;
  box-sizing: border-box;
  padding: 10px 0;
  background: white;
}
.titles {
  line-height: 19px;
  color: #757575;
  font-size: 10px;
}
.money_bar {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 20px 0;
  border-bottom: solid 1px lightgray;
}
.money_logo {
  font-size: 19px;
  font-weight: bold;
  line-height: 19px;
  color: #212121;
  margin-top: 2px;
}
.money_ipt {
  border: none;
  outline: none;
  font-size: 19px;
  margin-left: 5px;
}
.check_money {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 19px;
}
.check_item {
  width: 50px;
  height: 22px;
  background: #ffffff;
  border: 1px solid #46a1ff;
  text-align: center;
  margin: 10px;
  opacity: 1;
  border-radius: 2px;
  font-size: 9px;
  line-height: 22px;
  color: #46a1ff;
}
.send_btn {
  width: 100%;
  height: 31px;
  background: #46a1ff;
  opacity: 1;
  border-radius: 4px;
  text-align: center;
  line-height: 31px;
  font-size: 10px;
  color: #ffffff;
  margin-top: 62px;
}
</style>



// WEBPACK FOOTER //
// src/invest/index.vue